var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 279 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11613_13162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9C0.5 4.02944 4.52944 0 9.5 0H269.5C274.471 0 278.5 4.02944 278.5 9V126H0.5V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 77.5C20.567 77.5 19 75.933 19 74C19 72.067 20.567 70.5 22.5 70.5C24.433 70.5 26 72.067 26 74C26 75.933 24.433 77.5 22.5 77.5ZM22.5 78C24.7091 78 26.5 76.2091 26.5 74C26.5 71.7909 24.7091 70 22.5 70C20.2909 70 18.5 71.7909 18.5 74C18.5 76.2091 20.2909 78 22.5 78Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0008 75.5C22.0008 75.2239 22.2246 75 22.5008 75C22.7769 75 23.0008 75.2239 23.0008 75.5C23.0008 75.7761 22.7769 76 22.5008 76C22.2246 76 22.0008 75.7761 22.0008 75.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0498 72.4975C22.0231 72.2311 22.2323 72 22.5 72C22.7677 72 22.9769 72.2311 22.9502 72.4975L22.7749 74.2512C22.7608 74.3925 22.6419 74.5 22.5 74.5C22.3581 74.5 22.2392 74.3925 22.2251 74.2512L22.0498 72.4975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1923 73.0577C60.2978 72.9522 60.2892 72.777 60.1685 72.6893C59.1382 71.9412 57.8706 71.5 56.5 71.5C55.1293 71.5 53.8618 71.9412 52.8315 72.6893C52.7108 72.777 52.7022 72.9522 52.8077 73.0577C52.8969 73.147 53.0392 73.156 53.1416 73.0821C54.0865 72.4012 55.2464 72 56.5 72C57.7536 72 58.9135 72.4012 59.8583 73.0821C59.9607 73.156 60.103 73.147 60.1923 73.0577Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1145 74.1355C59.2225 74.0275 59.2113 73.8463 59.0831 73.7631C58.3395 73.2804 57.4525 73 56.5 73C55.5475 73 54.6604 73.2804 53.9169 73.7631C53.7887 73.8463 53.7774 74.0275 53.8855 74.1355C53.9718 74.2219 54.1088 74.2338 54.2117 74.168C54.8722 73.7452 55.6575 73.5 56.5 73.5C57.3425 73.5 58.1277 73.7452 58.7883 74.168C58.8911 74.2338 59.0281 74.2219 59.1145 74.1355Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.023 75.227C58.1361 75.1139 58.1154 74.9247 57.9729 74.8522C57.5308 74.627 57.0302 74.5 56.5 74.5C55.9698 74.5 55.4692 74.627 55.027 74.8522C54.8846 74.9247 54.8639 75.1139 54.9769 75.227L54.9845 75.2345C55.0646 75.3147 55.1883 75.3297 55.2901 75.2798C55.6552 75.1006 56.0658 75 56.5 75C56.9341 75 57.3448 75.1006 57.7099 75.2798C57.8117 75.3297 57.9353 75.3147 58.0155 75.2345L58.023 75.227Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0303 76.2197C57.1279 76.122 57.1289 75.9604 57.0103 75.8898C56.8609 75.801 56.6864 75.75 56.5 75.75C56.3136 75.75 56.1391 75.801 55.9897 75.8898C55.871 75.9604 55.872 76.122 55.9696 76.2197L56.3232 76.5732C56.4208 76.6709 56.5791 76.6709 56.6768 76.5732L57.0303 76.2197Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.75 72.5C87.8881 72.5 88 72.3881 88 72.25C88 72.1119 87.8881 72 87.75 72C87.6119 72 87.5 72.1119 87.5 72.25C87.5 72.3881 87.6119 72.5 87.75 72.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 72.5C88.6381 72.5 88.75 72.3881 88.75 72.25C88.75 72.1119 88.6381 72 88.5 72C88.3619 72 88.25 72.1119 88.25 72.25C88.25 72.3881 88.3619 72.5 88.5 72.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 72.25C89.5 72.3881 89.3881 72.5 89.25 72.5C89.1119 72.5 89 72.3881 89 72.25C89 72.1119 89.1119 72 89.25 72C89.3881 72 89.5 72.1119 89.5 72.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 72C86.5 71.4477 86.9477 71 87.5 71H93C93.5523 71 94 71.4477 94 72V74C94 74.1381 93.8881 74.25 93.75 74.25C93.6119 74.25 93.5 74.1381 93.5 74V73.5H87V76C87 76.2761 87.2239 76.5 87.5 76.5H90.25C90.3881 76.5 90.5 76.6119 90.5 76.75C90.5 76.8881 90.3881 77 90.25 77H87.5C86.9477 77 86.5 76.5523 86.5 76V72ZM87 73H93.5V72C93.5 71.7239 93.2761 71.5 93 71.5H87.5C87.2239 71.5 87 71.7239 87 72V73Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 76.25C94.5 77.2165 93.7165 78 92.75 78C91.7835 78 91 77.2165 91 76.25C91 75.2835 91.7835 74.5 92.75 74.5C93.7165 74.5 94.5 75.2835 94.5 76.25ZM91.75 76.25C91.75 76.3881 91.8619 76.5 92 76.5H93.5C93.6381 76.5 93.75 76.3881 93.75 76.25C93.75 76.1119 93.6381 76 93.5 76H92C91.8619 76 91.75 76.1119 91.75 76.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.551 71.1115C120.518 71.2354 120.5 71.3656 120.5 71.5C120.5 72.3284 121.172 73 122 73C122.135 73 122.266 72.9822 122.39 72.9487L125.561 76.0745C125.521 76.2094 125.5 76.3522 125.5 76.5C125.5 77.3284 126.172 78 127 78C127.828 78 128.5 77.3284 128.5 76.5C128.5 75.6716 127.828 75 127 75C126.852 75 126.709 75.0214 126.575 75.0612L123.449 71.8904C123.482 71.766 123.5 71.6351 123.5 71.5C123.5 70.6716 122.828 70 122 70C121.866 70 121.735 70.0177 121.611 70.0508L122.682 71.1213L122.5 72L121.621 72.182L120.551 71.1115ZM127.236 75.621L127.5 75.634L127.643 75.8565L127.866 76L127.879 76.2645L128 76.5L127.879 76.7355L127.866 77L127.643 77.1435L127.5 77.366L127.236 77.379L127 77.5L126.764 77.379L126.5 77.366L126.357 77.1435L126.134 77L126.121 76.7355L126 76.5L126.121 76.2645L126.134 76L126.357 75.8565L126.5 75.634L126.764 75.621L127 75.5L127.236 75.621Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.823 72.3232C156.921 72.2256 157.079 72.2256 157.177 72.3232L158.5 73.6464L159.823 72.3232C159.921 72.2256 160.079 72.2256 160.177 72.3232C160.274 72.4209 160.274 72.5791 160.177 72.6768L158.854 74L160.177 75.3232C160.274 75.4209 160.274 75.5791 160.177 75.6768C160.079 75.7744 159.921 75.7744 159.823 75.6768L158.5 74.3536L157.177 75.6768C157.079 75.7744 156.921 75.7744 156.823 75.6768C156.726 75.5791 156.726 75.4209 156.823 75.3232L158.146 74L156.823 72.6768C156.726 72.5791 156.726 72.4209 156.823 72.3232Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 71.2002C190.279 71.2002 190.1 71.3793 190.1 71.6002C190.1 71.8211 190.279 72.0002 190.5 72.0002C192.709 72.0002 194.5 73.7911 194.5 76.0002C194.5 76.2211 194.679 76.4002 194.9 76.4002C195.121 76.4002 195.3 76.2211 195.3 76.0002C195.3 73.3492 193.151 71.2002 190.5 71.2002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1 73.6002C190.1 73.3793 190.279 73.2002 190.5 73.2002C192.046 73.2002 193.3 74.4538 193.3 76.0002C193.3 76.2211 193.121 76.4002 192.9 76.4002C192.679 76.4002 192.5 76.2211 192.5 76.0002C192.5 74.8956 191.605 74.0002 190.5 74.0002C190.279 74.0002 190.1 73.8211 190.1 73.6002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7 76.0002C189.7 75.5584 190.058 75.2002 190.5 75.2002C190.942 75.2002 191.3 75.5584 191.3 76.0002C191.3 76.442 190.942 76.8002 190.5 76.8002C190.058 76.8002 189.7 76.442 189.7 76.0002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5 77.5C224.567 77.5 223 75.933 223 74C223 72.067 224.567 70.5 226.5 70.5C228.433 70.5 230 72.067 230 74C230 75.933 228.433 77.5 226.5 77.5ZM226.5 78C228.709 78 230.5 76.2091 230.5 74C230.5 71.7909 228.709 70 226.5 70C224.291 70 222.5 71.7909 222.5 74C222.5 76.2091 224.291 78 226.5 78Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.001 75.5C226.001 75.2239 226.225 75 226.501 75C226.777 75 227.001 75.2239 227.001 75.5C227.001 75.7761 226.777 76 226.501 76C226.225 76 226.001 75.7761 226.001 75.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05 72.4975C226.023 72.2311 226.232 72 226.5 72C226.768 72 226.977 72.2311 226.95 72.4975L226.775 74.2512C226.761 74.3925 226.642 74.5 226.5 74.5C226.358 74.5 226.239 74.3925 226.225 74.2512L226.05 72.4975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 63,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11613_13162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.983 70.917C257.827 70.7608 257.573 70.7608 257.417 70.917C257.261 71.0732 257.261 71.3264 257.417 71.4826L260.186 74.2512C260.205 74.2761 260.228 74.2985 260.253 74.3181L263.017 77.0826C263.173 77.2389 263.427 77.2389 263.583 77.0826C263.739 76.9264 263.739 76.6732 263.583 76.517L263.313 76.247C264.445 74.8336 264.356 72.7645 263.046 71.4542C262.889 71.298 262.636 71.298 262.48 71.4542C262.324 71.6104 262.324 71.8637 262.48 72.0199C263.477 73.0173 263.565 74.5801 262.743 75.6768L262.169 75.1029C262.683 74.3264 262.599 73.2698 261.914 72.5856C261.758 72.4294 261.505 72.4294 261.349 72.5856C261.192 72.7418 261.192 72.9951 261.349 73.1513C261.718 73.5207 261.796 74.0712 261.583 74.5172L260.787 73.7207C260.784 73.7182 260.782 73.7157 260.779 73.7133L257.983 70.917Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.795 73.2744C257.852 73.061 257.725 72.8417 257.512 72.7848C257.298 72.7278 257.079 72.8546 257.022 73.068C256.702 74.2678 257.012 75.6028 257.955 76.5453C258.111 76.7015 258.364 76.7015 258.52 76.5453C258.676 76.3891 258.676 76.1358 258.52 75.9796C257.788 75.2472 257.545 74.2097 257.795 73.2744Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46 74.5996C259.35 74.4084 259.105 74.3429 258.914 74.4535C258.723 74.5641 258.657 74.8087 258.768 75C258.854 75.1484 258.96 75.2877 259.086 75.4139C259.242 75.5701 259.495 75.5701 259.652 75.4139C259.808 75.2577 259.808 75.0044 259.652 74.8482C259.575 74.7718 259.512 74.6881 259.46 74.5996Z",
    fill: "#EF4444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 44.2002C20.7791 44.2002 20.6 44.3793 20.6 44.6002C20.6 44.8211 20.7791 45.0002 21 45.0002C23.2092 45.0002 25 46.7911 25 49.0002C25 49.2211 25.1791 49.4002 25.4 49.4002C25.6209 49.4002 25.8 49.2211 25.8 49.0002C25.8 46.3492 23.651 44.2002 21 44.2002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 46.6002C20.6 46.3793 20.7791 46.2002 21 46.2002C22.5464 46.2002 23.8 47.4538 23.8 49.0002C23.8 49.2211 23.6209 49.4002 23.4 49.4002C23.1791 49.4002 23 49.2211 23 49.0002C23 47.8956 22.1046 47.0002 21 47.0002C20.7791 47.0002 20.6 46.8211 20.6 46.6002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 49.0002C20.2 48.5584 20.5582 48.2002 21 48.2002C21.4418 48.2002 21.8 48.5584 21.8 49.0002C21.8 49.442 21.4418 49.8002 21 49.8002C20.5582 49.8002 20.2 49.442 20.2 49.0002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 50.5C55.067 50.5 53.5 48.933 53.5 47C53.5 45.067 55.067 43.5 57 43.5C58.933 43.5 60.5 45.067 60.5 47C60.5 48.933 58.933 50.5 57 50.5ZM57 51C59.2091 51 61 49.2091 61 47C61 44.7909 59.2091 43 57 43C54.7909 43 53 44.7909 53 47C53 49.2091 54.7909 51 57 51Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5008 48.5C56.5008 48.2239 56.7246 48 57.0008 48C57.2769 48 57.5008 48.2239 57.5008 48.5C57.5008 48.7761 57.2769 49 57.0008 49C56.7246 49 56.5008 48.7761 56.5008 48.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5498 45.4975C56.5231 45.2311 56.7323 45 57 45C57.2677 45 57.4769 45.2311 57.4502 45.4975L57.2749 47.2512C57.2608 47.3925 57.1419 47.5 57 47.5C56.8581 47.5 56.7392 47.3925 56.7251 47.2512L56.5498 45.4975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3232 45.3232C89.4209 45.2256 89.5791 45.2256 89.6768 45.3232L91 46.6464L92.3232 45.3232C92.4209 45.2256 92.5791 45.2256 92.6768 45.3232C92.7744 45.4209 92.7744 45.5791 92.6768 45.6768L91.3536 47L92.6768 48.3232C92.7744 48.4209 92.7744 48.5791 92.6768 48.6768C92.5791 48.7744 92.4209 48.7744 92.3232 48.6768L91 47.3536L89.6768 48.6768C89.5791 48.7744 89.4209 48.7744 89.3232 48.6768C89.2256 48.5791 89.2256 48.4209 89.3232 48.3232L90.6464 47L89.3232 45.6768C89.2256 45.5791 89.2256 45.4209 89.3232 45.3232Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11613_13162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.483 43.917C122.327 43.7608 122.073 43.7608 121.917 43.917C121.761 44.0732 121.761 44.3264 121.917 44.4826L124.686 47.2512C124.705 47.2761 124.728 47.2985 124.753 47.3181L127.517 50.0826C127.673 50.2389 127.927 50.2389 128.083 50.0826C128.239 49.9264 128.239 49.6732 128.083 49.517L127.813 49.247C128.945 47.8336 128.856 45.7645 127.546 44.4542C127.389 44.298 127.136 44.298 126.98 44.4542C126.824 44.6104 126.824 44.8637 126.98 45.0199C127.977 46.0173 128.065 47.5801 127.243 48.6768L126.669 48.1029C127.183 47.3264 127.098 46.2698 126.414 45.5856C126.258 45.4294 126.005 45.4294 125.849 45.5856C125.692 45.7418 125.692 45.9951 125.849 46.1513C126.218 46.5207 126.296 47.0712 126.083 47.5172L125.287 46.7207C125.284 46.7182 125.282 46.7157 125.279 46.7133L122.483 43.917Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.295 46.2744C122.352 46.061 122.225 45.8417 122.012 45.7848C121.798 45.7278 121.579 45.8546 121.522 46.068C121.202 47.2678 121.512 48.6028 122.454 49.5453C122.611 49.7015 122.864 49.7015 123.02 49.5453C123.176 49.3891 123.176 49.1358 123.02 48.9796C122.288 48.2472 122.045 47.2097 122.295 46.2744Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.96 47.5996C123.85 47.4084 123.605 47.3429 123.414 47.4535C123.223 47.5641 123.157 47.8087 123.268 48C123.353 48.1484 123.46 48.2877 123.586 48.4139C123.742 48.5701 123.995 48.5701 124.152 48.4139C124.308 48.2577 124.308 48.0044 124.152 47.8482C124.075 47.7718 124.011 47.6881 123.96 47.5996Z",
    fill: "#EF4444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.692 46.0577C162.798 45.9522 162.789 45.777 162.668 45.6893C161.638 44.9412 160.371 44.5 159 44.5C157.629 44.5 156.362 44.9412 155.332 45.6893C155.211 45.777 155.202 45.9522 155.308 46.0577C155.397 46.147 155.539 46.156 155.642 46.0821C156.586 45.4012 157.746 45 159 45C160.254 45 161.413 45.4012 162.358 46.0821C162.461 46.156 162.603 46.147 162.692 46.0577Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.614 47.1355C161.723 47.0275 161.711 46.8463 161.583 46.7631C160.84 46.2804 159.953 46 159 46C158.047 46 157.16 46.2804 156.417 46.7631C156.289 46.8463 156.277 47.0275 156.385 47.1355C156.472 47.2219 156.609 47.2338 156.712 47.168C157.372 46.7452 158.157 46.5 159 46.5C159.842 46.5 160.628 46.7452 161.288 47.168C161.391 47.2338 161.528 47.2219 161.614 47.1355Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.523 48.227C160.636 48.1139 160.615 47.9247 160.473 47.8522C160.031 47.627 159.53 47.5 159 47.5C158.47 47.5 157.969 47.627 157.527 47.8522C157.385 47.9247 157.364 48.1139 157.477 48.227L157.484 48.2345C157.565 48.3147 157.688 48.3297 157.79 48.2798C158.155 48.1006 158.566 48 159 48C159.434 48 159.845 48.1006 160.21 48.2798C160.312 48.3297 160.435 48.3147 160.516 48.2345L160.523 48.227Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53 49.2197C159.628 49.122 159.629 48.9604 159.51 48.8898C159.361 48.801 159.186 48.75 159 48.75C158.814 48.75 158.639 48.801 158.49 48.8898C158.371 48.9604 158.372 49.122 158.47 49.2197L158.823 49.5732C158.921 49.6709 159.079 49.6709 159.177 49.5732L159.53 49.2197Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25 45.5C190.388 45.5 190.5 45.3881 190.5 45.25C190.5 45.1119 190.388 45 190.25 45C190.112 45 190 45.1119 190 45.25C190 45.3881 190.112 45.5 190.25 45.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 45.5C191.138 45.5 191.25 45.3881 191.25 45.25C191.25 45.1119 191.138 45 191 45C190.862 45 190.75 45.1119 190.75 45.25C190.75 45.3881 190.862 45.5 191 45.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 45.25C192 45.3881 191.888 45.5 191.75 45.5C191.612 45.5 191.5 45.3881 191.5 45.25C191.5 45.1119 191.612 45 191.75 45C191.888 45 192 45.1119 192 45.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 45C189 44.4477 189.448 44 190 44H195.5C196.052 44 196.5 44.4477 196.5 45V47C196.5 47.1381 196.388 47.25 196.25 47.25C196.112 47.25 196 47.1381 196 47V46.5H189.5V49C189.5 49.2761 189.724 49.5 190 49.5H192.75C192.888 49.5 193 49.6119 193 49.75C193 49.8881 192.888 50 192.75 50H190C189.448 50 189 49.5523 189 49V45ZM189.5 46H196V45C196 44.7239 195.776 44.5 195.5 44.5H190C189.724 44.5 189.5 44.7239 189.5 45V46Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 49.25C197 50.2165 196.216 51 195.25 51C194.284 51 193.5 50.2165 193.5 49.25C193.5 48.2835 194.284 47.5 195.25 47.5C196.216 47.5 197 48.2835 197 49.25ZM194.25 49.25C194.25 49.3881 194.362 49.5 194.5 49.5H196C196.138 49.5 196.25 49.3881 196.25 49.25C196.25 49.1119 196.138 49 196 49H194.5C194.362 49 194.25 49.1119 194.25 49.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.051 44.1115C223.018 44.2354 223 44.3656 223 44.5C223 45.3284 223.672 46 224.5 46C224.635 46 224.766 45.9822 224.89 45.9487L228.061 49.0745C228.021 49.2094 228 49.3522 228 49.5C228 50.3284 228.672 51 229.5 51C230.328 51 231 50.3284 231 49.5C231 48.6716 230.328 48 229.5 48C229.352 48 229.209 48.0214 229.075 48.0612L225.949 44.8904C225.982 44.766 226 44.6351 226 44.5C226 43.6716 225.328 43 224.5 43C224.366 43 224.235 43.0177 224.111 43.0508L225.182 44.1213L225 45L224.121 45.182L223.051 44.1115ZM229.736 48.621L230 48.634L230.143 48.8565L230.366 49L230.379 49.2645L230.5 49.5L230.379 49.7355L230.366 50L230.143 50.1435L230 50.366L229.736 50.379L229.5 50.5L229.264 50.379L229 50.366L228.857 50.1435L228.634 50L228.621 49.7355L228.5 49.5L228.621 49.2645L228.634 49L228.857 48.8565L229 48.634L229.264 48.621L229.5 48.5L229.736 48.621Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 36,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 50.5C259.067 50.5 257.5 48.933 257.5 47C257.5 45.067 259.067 43.5 261 43.5C262.933 43.5 264.5 45.067 264.5 47C264.5 48.933 262.933 50.5 261 50.5ZM261 51C263.209 51 265 49.2091 265 47C265 44.7909 263.209 43 261 43C258.791 43 257 44.7909 257 47C257 49.2091 258.791 51 261 51Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.501 48.5C260.501 48.2239 260.725 48 261.001 48C261.277 48 261.501 48.2239 261.501 48.5C261.501 48.7761 261.277 49 261.001 49C260.725 49 260.501 48.7761 260.501 48.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.55 45.4975C260.523 45.2311 260.732 45 261 45C261.268 45 261.477 45.2311 261.45 45.4975L261.275 47.2512C261.261 47.3925 261.142 47.5 261 47.5C260.858 47.5 260.739 47.3925 260.725 47.2512L260.55 45.4975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1923 100.058C26.2978 99.9522 26.2892 99.777 26.1685 99.6893C25.1382 98.9412 23.8706 98.5 22.5 98.5C21.1293 98.5 19.8618 98.9412 18.8315 99.6893C18.7108 99.777 18.7022 99.9522 18.8077 100.058C18.8969 100.147 19.0392 100.156 19.1416 100.082C20.0865 99.4012 21.2464 99 22.5 99C23.7536 99 24.9135 99.4012 25.8583 100.082C25.9607 100.156 26.103 100.147 26.1923 100.058Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1145 101.136C25.2225 101.027 25.2113 100.846 25.0831 100.763C24.3395 100.28 23.4525 100 22.5 100C21.5475 100 20.6604 100.28 19.9169 100.763C19.7887 100.846 19.7774 101.027 19.8855 101.136C19.9718 101.222 20.1088 101.234 20.2117 101.168C20.8722 100.745 21.6575 100.5 22.5 100.5C23.3425 100.5 24.1277 100.745 24.7883 101.168C24.8911 101.234 25.0281 101.222 25.1145 101.136Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.023 102.227C24.1361 102.114 24.1154 101.925 23.9729 101.852C23.5308 101.627 23.0302 101.5 22.5 101.5C21.9698 101.5 21.4692 101.627 21.027 101.852C20.8846 101.925 20.8639 102.114 20.9769 102.227L20.9845 102.234C21.0646 102.315 21.1883 102.33 21.2901 102.28C21.6552 102.101 22.0658 102 22.5 102C22.9341 102 23.3448 102.101 23.7099 102.28C23.8117 102.33 23.9353 102.315 24.0155 102.234L24.023 102.227Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0303 103.22C23.1279 103.122 23.1289 102.96 23.0103 102.89C22.8609 102.801 22.6864 102.75 22.5 102.75C22.3136 102.75 22.1391 102.801 21.9897 102.89C21.871 102.96 21.872 103.122 21.9696 103.22L22.3232 103.573C22.4208 103.671 22.5791 103.671 22.6768 103.573L23.0303 103.22Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5508 98.1115C52.5177 98.2354 52.5 98.3656 52.5 98.5C52.5 99.3284 53.1716 100 54 100C54.1351 100 54.2659 99.9822 54.3904 99.9487L57.5612 103.075C57.5214 103.209 57.5 103.352 57.5 103.5C57.5 104.328 58.1716 105 59 105C59.8284 105 60.5 104.328 60.5 103.5C60.5 102.672 59.8284 102 59 102C58.8522 102 58.7094 102.021 58.5745 102.061L55.4487 98.8904C55.4821 98.766 55.5 98.6351 55.5 98.5C55.5 97.6716 54.8284 97 54 97C53.8656 97 53.7354 97.0177 53.6115 97.0508L54.682 98.1213L54.5 99L53.6213 99.182L52.5508 98.1115ZM59.2355 102.621L59.5 102.634L59.6435 102.857L59.866 103L59.879 103.264L60 103.5L59.879 103.736L59.866 104L59.6435 104.143L59.5 104.366L59.2355 104.379L59 104.5L58.7645 104.379L58.5 104.366L58.3565 104.143L58.134 104L58.121 103.736L58 103.5L58.121 103.264L58.134 103L58.3565 102.857L58.5 102.634L58.7645 102.621L59 102.5L59.2355 102.621Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8232 99.3232C88.9209 99.2256 89.0791 99.2256 89.1768 99.3232L90.5 100.646L91.8232 99.3232C91.9209 99.2256 92.0791 99.2256 92.1768 99.3232C92.2744 99.4209 92.2744 99.5791 92.1768 99.6768L90.8536 101L92.1768 102.323C92.2744 102.421 92.2744 102.579 92.1768 102.677C92.0791 102.774 91.9209 102.774 91.8232 102.677L90.5 101.354L89.1768 102.677C89.0791 102.774 88.9209 102.774 88.8232 102.677C88.7256 102.579 88.7256 102.421 88.8232 102.323L90.1464 101L88.8232 99.6768C88.7256 99.5791 88.7256 99.4209 88.8232 99.3232Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5 98.2002C122.279 98.2002 122.1 98.3793 122.1 98.6002C122.1 98.8211 122.279 99.0002 122.5 99.0002C124.709 99.0002 126.5 100.791 126.5 103C126.5 103.221 126.679 103.4 126.9 103.4C127.121 103.4 127.3 103.221 127.3 103C127.3 100.349 125.151 98.2002 122.5 98.2002Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1 100.6C122.1 100.379 122.279 100.2 122.5 100.2C124.046 100.2 125.3 101.454 125.3 103C125.3 103.221 125.121 103.4 124.9 103.4C124.679 103.4 124.5 103.221 124.5 103C124.5 101.896 123.605 101 122.5 101C122.279 101 122.1 100.821 122.1 100.6Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7 103C121.7 102.558 122.058 102.2 122.5 102.2C122.942 102.2 123.3 102.558 123.3 103C123.3 103.442 122.942 103.8 122.5 103.8C122.058 103.8 121.7 103.442 121.7 103Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11613_13162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.983 97.917C155.827 97.7608 155.573 97.7608 155.417 97.917C155.261 98.0732 155.261 98.3264 155.417 98.4826L158.186 101.251C158.205 101.276 158.228 101.299 158.253 101.318L161.017 104.083C161.173 104.239 161.427 104.239 161.583 104.083C161.739 103.926 161.739 103.673 161.583 103.517L161.313 103.247C162.445 101.834 162.356 99.7645 161.046 98.4542C160.889 98.298 160.636 98.298 160.48 98.4542C160.324 98.6104 160.324 98.8637 160.48 99.0199C161.477 100.017 161.565 101.58 160.743 102.677L160.169 102.103C160.683 101.326 160.598 100.27 159.914 99.5856C159.758 99.4294 159.505 99.4294 159.349 99.5856C159.192 99.7418 159.192 99.9951 159.349 100.151C159.718 100.521 159.796 101.071 159.583 101.517L158.787 100.721C158.784 100.718 158.782 100.716 158.779 100.713L155.983 97.917Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.795 100.274C155.852 100.061 155.725 99.8417 155.512 99.7848C155.298 99.7278 155.079 99.8546 155.022 100.068C154.702 101.268 155.012 102.603 155.954 103.545C156.111 103.702 156.364 103.702 156.52 103.545C156.676 103.389 156.676 103.136 156.52 102.98C155.788 102.247 155.545 101.21 155.795 100.274Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46 101.6C157.35 101.408 157.105 101.343 156.914 101.454C156.723 101.564 156.657 101.809 156.768 102C156.853 102.148 156.96 102.288 157.086 102.414C157.242 102.57 157.495 102.57 157.652 102.414C157.808 102.258 157.808 102.004 157.652 101.848C157.575 101.772 157.511 101.688 157.46 101.6Z",
    fill: "#EF4444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5 104.5C190.567 104.5 189 102.933 189 101C189 99.067 190.567 97.5 192.5 97.5C194.433 97.5 196 99.067 196 101C196 102.933 194.433 104.5 192.5 104.5ZM192.5 105C194.709 105 196.5 103.209 196.5 101C196.5 98.7909 194.709 97 192.5 97C190.291 97 188.5 98.7909 188.5 101C188.5 103.209 190.291 105 192.5 105Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.001 102.5C192.001 102.224 192.225 102 192.501 102C192.777 102 193.001 102.224 193.001 102.5C193.001 102.776 192.777 103 192.501 103C192.225 103 192.001 102.776 192.001 102.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.05 99.4975C192.023 99.2311 192.232 99 192.5 99C192.768 99 192.977 99.2311 192.95 99.4975L192.775 101.251C192.761 101.392 192.642 101.5 192.5 101.5C192.358 101.5 192.239 101.392 192.225 101.251L192.05 99.4975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.75 99.5C223.888 99.5 224 99.3881 224 99.25C224 99.1119 223.888 99 223.75 99C223.612 99 223.5 99.1119 223.5 99.25C223.5 99.3881 223.612 99.5 223.75 99.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5 99.5C224.638 99.5 224.75 99.3881 224.75 99.25C224.75 99.1119 224.638 99 224.5 99C224.362 99 224.25 99.1119 224.25 99.25C224.25 99.3881 224.362 99.5 224.5 99.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5 99.25C225.5 99.3881 225.388 99.5 225.25 99.5C225.112 99.5 225 99.3881 225 99.25C225 99.1119 225.112 99 225.25 99C225.388 99 225.5 99.1119 225.5 99.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5 99C222.5 98.4477 222.948 98 223.5 98H229C229.552 98 230 98.4477 230 99V101C230 101.138 229.888 101.25 229.75 101.25C229.612 101.25 229.5 101.138 229.5 101V100.5H223V103C223 103.276 223.224 103.5 223.5 103.5H226.25C226.388 103.5 226.5 103.612 226.5 103.75C226.5 103.888 226.388 104 226.25 104H223.5C222.948 104 222.5 103.552 222.5 103V99ZM223 100H229.5V99C229.5 98.7239 229.276 98.5 229 98.5H223.5C223.224 98.5 223 98.7239 223 99V100Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5 103.25C230.5 104.216 229.716 105 228.75 105C227.784 105 227 104.216 227 103.25C227 102.284 227.784 101.5 228.75 101.5C229.716 101.5 230.5 102.284 230.5 103.25ZM227.75 103.25C227.75 103.388 227.862 103.5 228 103.5H229.5C229.638 103.5 229.75 103.388 229.75 103.25C229.75 103.112 229.638 103 229.5 103H228C227.862 103 227.75 103.112 227.75 103.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 90,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5 104.5C258.567 104.5 257 102.933 257 101C257 99.067 258.567 97.5 260.5 97.5C262.433 97.5 264 99.067 264 101C264 102.933 262.433 104.5 260.5 104.5ZM260.5 105C262.709 105 264.5 103.209 264.5 101C264.5 98.7909 262.709 97 260.5 97C258.291 97 256.5 98.7909 256.5 101C256.5 103.209 258.291 105 260.5 105Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.001 102.5C260.001 102.224 260.225 102 260.501 102C260.777 102 261.001 102.224 261.001 102.5C261.001 102.776 260.777 103 260.501 103C260.225 103 260.001 102.776 260.001 102.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.05 99.4975C260.023 99.2311 260.232 99 260.5 99C260.768 99 260.977 99.2311 260.95 99.4975L260.775 101.251C260.761 101.392 260.642 101.5 260.5 101.5C260.358 101.5 260.239 101.392 260.225 101.251L260.05 99.4975Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1923 127.058C26.2978 126.952 26.2892 126.777 26.1685 126.689C25.1382 125.941 23.8706 125.5 22.5 125.5C21.1293 125.5 19.8618 125.941 18.8315 126.689C18.7108 126.777 18.7022 126.952 18.8077 127.058C18.8969 127.147 19.0392 127.156 19.1416 127.082C20.0865 126.401 21.2464 126 22.5 126C23.7536 126 24.9135 126.401 25.8583 127.082C25.9607 127.156 26.103 127.147 26.1923 127.058Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1145 128.136C25.2225 128.027 25.2113 127.846 25.0831 127.763C24.3395 127.28 23.4525 127 22.5 127C21.5475 127 20.6604 127.28 19.9169 127.763C19.7887 127.846 19.7774 128.027 19.8855 128.136C19.9718 128.222 20.1088 128.234 20.2117 128.168C20.8722 127.745 21.6575 127.5 22.5 127.5C23.3425 127.5 24.1277 127.745 24.7883 128.168C24.8911 128.234 25.0281 128.222 25.1145 128.136Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.023 129.227C24.1361 129.114 24.1154 128.925 23.9729 128.852C23.5308 128.627 23.0302 128.5 22.5 128.5C21.9698 128.5 21.4692 128.627 21.027 128.852C20.8846 128.925 20.8639 129.114 20.9769 129.227L20.9845 129.234C21.0646 129.315 21.1883 129.33 21.2901 129.28C21.6552 129.101 22.0658 129 22.5 129C22.9341 129 23.3448 129.101 23.7099 129.28C23.8117 129.33 23.9353 129.315 24.0155 129.234L24.023 129.227Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0303 130.22C23.1279 130.122 23.1289 129.96 23.0103 129.89C22.8609 129.801 22.6864 129.75 22.5 129.75C22.3136 129.75 22.1391 129.801 21.9897 129.89C21.871 129.96 21.872 130.122 21.9696 130.22L22.3232 130.573C22.4208 130.671 22.5791 130.671 22.6768 130.573L23.0303 130.22Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5508 125.111C52.5177 125.235 52.5 125.366 52.5 125.5C52.5 126.328 53.1716 127 54 127C54.1351 127 54.2659 126.982 54.3904 126.949L57.5612 130.075C57.5214 130.209 57.5 130.352 57.5 130.5C57.5 131.328 58.1716 132 59 132C59.8284 132 60.5 131.328 60.5 130.5C60.5 129.672 59.8284 129 59 129C58.8522 129 58.7094 129.021 58.5745 129.061L55.4487 125.89C55.4821 125.766 55.5 125.635 55.5 125.5C55.5 124.672 54.8284 124 54 124C53.8656 124 53.7354 124.018 53.6115 124.051L54.682 125.121L54.5 126L53.6213 126.182L52.5508 125.111ZM59.2355 129.621L59.5 129.634L59.6435 129.857L59.866 130L59.879 130.264L60 130.5L59.879 130.736L59.866 131L59.6435 131.143L59.5 131.366L59.2355 131.379L59 131.5L58.7645 131.379L58.5 131.366L58.3565 131.143L58.134 131L58.121 130.736L58 130.5L58.121 130.264L58.134 130L58.3565 129.857L58.5 129.634L58.7645 129.621L59 129.5L59.2355 129.621Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11613_13162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.983 124.917C121.827 124.761 121.573 124.761 121.417 124.917C121.261 125.073 121.261 125.326 121.417 125.483L124.186 128.251C124.205 128.276 124.228 128.299 124.253 128.318L127.017 131.083C127.173 131.239 127.427 131.239 127.583 131.083C127.739 130.926 127.739 130.673 127.583 130.517L127.313 130.247C128.445 128.834 128.356 126.765 127.046 125.454C126.889 125.298 126.636 125.298 126.48 125.454C126.324 125.61 126.324 125.864 126.48 126.02C127.477 127.017 127.565 128.58 126.743 129.677L126.169 129.103C126.683 128.326 126.598 127.27 125.914 126.586C125.758 126.429 125.505 126.429 125.349 126.586C125.192 126.742 125.192 126.995 125.349 127.151C125.718 127.521 125.796 128.071 125.583 128.517L124.787 127.721C124.784 127.718 124.782 127.716 124.779 127.713L121.983 124.917Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.795 127.274C121.852 127.061 121.725 126.842 121.512 126.785C121.298 126.728 121.079 126.855 121.022 127.068C120.702 128.268 121.012 129.603 121.954 130.545C122.111 130.702 122.364 130.702 122.52 130.545C122.676 130.389 122.676 130.136 122.52 129.98C121.788 129.247 121.545 128.21 121.795 127.274Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.46 128.6C123.35 128.408 123.105 128.343 122.914 128.454C122.723 128.564 122.657 128.809 122.768 129C122.853 129.148 122.96 129.288 123.086 129.414C123.242 129.57 123.495 129.57 123.652 129.414C123.808 129.258 123.808 129.004 123.652 128.848C123.575 128.772 123.511 128.688 123.46 128.6Z",
    fill: "#EF4444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 131.5C156.567 131.5 155 129.933 155 128C155 126.067 156.567 124.5 158.5 124.5C160.433 124.5 162 126.067 162 128C162 129.933 160.433 131.5 158.5 131.5ZM158.5 132C160.709 132 162.5 130.209 162.5 128C162.5 125.791 160.709 124 158.5 124C156.291 124 154.5 125.791 154.5 128C154.5 130.209 156.291 132 158.5 132Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.001 129.5C158.001 129.224 158.225 129 158.501 129C158.777 129 159.001 129.224 159.001 129.5C159.001 129.776 158.777 130 158.501 130C158.225 130 158.001 129.776 158.001 129.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05 126.498C158.023 126.231 158.232 126 158.5 126C158.768 126 158.977 126.231 158.95 126.498L158.775 128.251C158.761 128.392 158.642 128.5 158.5 128.5C158.358 128.5 158.239 128.392 158.225 128.251L158.05 126.498Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 125.2C190.279 125.2 190.1 125.379 190.1 125.6C190.1 125.821 190.279 126 190.5 126C192.709 126 194.5 127.791 194.5 130C194.5 130.221 194.679 130.4 194.9 130.4C195.121 130.4 195.3 130.221 195.3 130C195.3 127.349 193.151 125.2 190.5 125.2Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1 127.6C190.1 127.379 190.279 127.2 190.5 127.2C192.046 127.2 193.3 128.454 193.3 130C193.3 130.221 193.121 130.4 192.9 130.4C192.679 130.4 192.5 130.221 192.5 130C192.5 128.896 191.605 128 190.5 128C190.279 128 190.1 127.821 190.1 127.6Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7 130C189.7 129.558 190.058 129.2 190.5 129.2C190.942 129.2 191.3 129.558 191.3 130C191.3 130.442 190.942 130.8 190.5 130.8C190.058 130.8 189.7 130.442 189.7 130Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.75 126.5C223.888 126.5 224 126.388 224 126.25C224 126.112 223.888 126 223.75 126C223.612 126 223.5 126.112 223.5 126.25C223.5 126.388 223.612 126.5 223.75 126.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5 126.5C224.638 126.5 224.75 126.388 224.75 126.25C224.75 126.112 224.638 126 224.5 126C224.362 126 224.25 126.112 224.25 126.25C224.25 126.388 224.362 126.5 224.5 126.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5 126.25C225.5 126.388 225.388 126.5 225.25 126.5C225.112 126.5 225 126.388 225 126.25C225 126.112 225.112 126 225.25 126C225.388 126 225.5 126.112 225.5 126.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5 126C222.5 125.448 222.948 125 223.5 125H229C229.552 125 230 125.448 230 126V128C230 128.138 229.888 128.25 229.75 128.25C229.612 128.25 229.5 128.138 229.5 128V127.5H223V130C223 130.276 223.224 130.5 223.5 130.5H226.25C226.388 130.5 226.5 130.612 226.5 130.75C226.5 130.888 226.388 131 226.25 131H223.5C222.948 131 222.5 130.552 222.5 130V126ZM223 127H229.5V126C229.5 125.724 229.276 125.5 229 125.5H223.5C223.224 125.5 223 125.724 223 126V127Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5 130.25C230.5 131.216 229.716 132 228.75 132C227.784 132 227 131.216 227 130.25C227 129.284 227.784 128.5 228.75 128.5C229.716 128.5 230.5 129.284 230.5 130.25ZM227.75 130.25C227.75 130.388 227.862 130.5 228 130.5H229.5C229.638 130.5 229.75 130.388 229.75 130.25C229.75 130.112 229.638 130 229.5 130H228C227.862 130 227.75 130.112 227.75 130.25Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 117,
    width: 24,
    height: 23,
    rx: 11.5,
    fill: "#FEF2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5 131.5C258.567 131.5 257 129.933 257 128C257 126.067 258.567 124.5 260.5 124.5C262.433 124.5 264 126.067 264 128C264 129.933 262.433 131.5 260.5 131.5ZM260.5 132C262.709 132 264.5 130.209 264.5 128C264.5 125.791 262.709 124 260.5 124C258.291 124 256.5 125.791 256.5 128C256.5 130.209 258.291 132 260.5 132Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.001 129.5C260.001 129.224 260.225 129 260.501 129C260.777 129 261.001 129.224 261.001 129.5C261.001 129.776 260.777 130 260.501 130C260.225 130 260.001 129.776 260.001 129.5Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.05 126.498C260.023 126.231 260.232 126 260.5 126C260.768 126 260.977 126.231 260.95 126.498L260.775 128.251C260.761 128.392 260.642 128.5 260.5 128.5C260.358 128.5 260.239 128.392 260.225 128.251L260.05 126.498Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.504028,
    y: 55.7266,
    width: 277.615,
    height: 70.5997,
    fill: "url(#paint0_linear_11613_13162)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11613_13162",
    x1: 139.311,
    y1: 55.7266,
    x2: 139.311,
    y2: 126.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11613_13162"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9C0.5 4.02944 4.52944 0 9.5 0H269.5C274.471 0 278.5 4.02944 278.5 9V126H0.5V9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11613_13162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(256.5 70)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11613_13162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(121 43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11613_13162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(154.5 97)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11613_13162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(120.5 124)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorState);
export default __webpack_public_path__ + "static/media/error-state.6c6f1e8340f0fa21e6aa851250727b18.svg";
export { ForwardRef as ReactComponent };